import { Grid, TableRow, TableCell } from "@material-ui/core";
import { WarningIcon } from "App/Assets";
import {
  InputFileCustom,
  MasterButton,
  Modal,
  TableWrapper,
  TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { DISABLED_BUTTON_SUBMIT, instance2 } from "App/constants";
import { useDatatables } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useEffect, useState } from "react";
import {
  urlAddRegistrationFile,
  getFileByRegistrationId,
  deleteFileByRegistrationId,
} from "./../helpers";

const SHOW_BUTTON_UPLOAD = {
  label: "Upload",
  color: "green",
  state: false,
};
function ModalUploadFilePenunjang({ setShowModal, registrationId }) {
  const [disabled, setDisabled] = useState(SHOW_BUTTON_UPLOAD);
  const [file, setFile] = useState("Upload File");
  const [rows, setRows] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (!isNull(file)) {
        const newFormData = new FormData();
        newFormData.append("fk_file", file);
        newFormData.append("registration_id", registrationId);
        newFormData.append("remark", "-");
        await instance2
          .post(urlAddRegistrationFile, newFormData)
          .then(async (res) => {
            defaultToastSuccess("Berhasil menambah file");
            await setNewData();
          });
        setDisabled(SHOW_BUTTON_UPLOAD);
      } else {
        defaultToastError("File tidak boleh kosong");
        setDisabled(SHOW_BUTTON_UPLOAD);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
      setDisabled(SHOW_BUTTON_UPLOAD);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async () => {
    if (!isNull(registrationId)) {
      const res = await getFileByRegistrationId(registrationId);
      if (res.state) {
        setRows(res.data);
      }
    }
  };

  return (
    <Modal
      title={`File Penunjang`}
      width='50%'
      subtitle='Tambahan untuk BPJS'
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={2}>
          <Grid item sm={10}>
            <Grid item xs={12}>
              <label
                htmlFor='file'
                style={{
                  fontWeight: 400,
                  color: "#BDBDBD",
                  fontSize: "11px",
                }}>
                File
              </label>
              <InputFileCustom
                label={"Upload File"}
                name={"file"}
                id={"file"}
                convertToBase64={false}
                initialNameFile={file}
                setFile={setFile}
              />
            </Grid>
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              style={{
                marginTop: "1.6rem",
              }}
              type='submit'
              color={disabled.color}
              name={disabled.label}
              size='md'
            />
          </Grid>
        </Grid>
      </form>

      <div className='mt-2'>
        <TableListFile rows={rows} setNewData={setNewData} />
      </div>
    </Modal>
  );
}

const TableListFile = ({ rows, setNewData }) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [id, setId] = useState("");

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  function clickDelete(row) {
    setId(row?.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function deleteList() {
    const res = await deleteFileByRegistrationId(id);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <DeleteConfirmDoubleModal
          setShowModalDeleteConfirm={setShowModalDeleteConfirm}
          confirmHandle={() => deleteList()}
        />
      )}

      <TableWrapper
        title='Daftar File'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        type='CUSTOM'
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  width='10%'
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width='10%'>
                  <TableAction
                    isUpdate={false}
                    clickDelete={() => clickDelete(row)}
                  />
                </TableCell>

                <TableCell align='left'>{row?.name}</TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
];

const DeleteConfirmDoubleModal = ({
  setShowModalDeleteConfirm,
  confirmHandle,
}) => {
  const [disabled, setDisabled] = useState(false);
  return (
    <div
      style={{
        zIndex: 99999,
        position: "absolute",
        top: "20%",
        display: "flex",
        width: "95%",
        justifyContent: "center",
      }}>
      <div
        style={{
          backgroundColor: "white",
          padding: "3rem 2rem 1rem 2rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: "20px",
          marginBottom: "1rem",
          borderRadius: "8px",
        }}>
        <WarningIcon />
        <p>Anda yakin ingin menghapus record ini?</p>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            outline={true}
            className={"mr-1 mt-1"}
            type={"button"}
            color='secondary'
            name='Batal'
            onClick={() => setShowModalDeleteConfirm(false)}
            size='md'
          />
          <MasterButton
            className={"mt-1"}
            type={"button"}
            color={disabled ? "secondary" : "danger"}
            onClick={() => {
              confirmHandle();
              setDisabled(true);
            }}
            name={disabled ? "Loading..." : "Hapus"}
            size='md'
          />
        </Grid>
      </div>
    </div>
  );
};

export default ModalUploadFilePenunjang;
